
import Message from './Message.js';

export default [
	Message
];
